import { render } from "./AllCases.vue?vue&type=template&id=31509c6e&scoped=true"
import script from "./AllCases.vue?vue&type=script&lang=js"
export * from "./AllCases.vue?vue&type=script&lang=js"

import "./AllCases.vue?vue&type=style&index=0&id=31509c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31509c6e"]])

export default __exports__